import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, LOCALE_ID, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LanguageOption, LanguageService } from '@shared/core';

@Component({
    selector: 'shared-language-switcher',
    imports: [CommonModule, FormsModule, NgSelectModule],
    templateUrl: './language-switcher.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcherComponent implements OnInit {
    languageService = inject(LanguageService);
    currentLocale = inject(LOCALE_ID);

    @Input() stylingClass: string = 'bg-white';

    availableLanguages = signal<LanguageOption[]>(this.languageService.getLanguages());
    selectedLanguage = signal<LanguageOption | null>(null);

    ngOnInit(): void {
        this.initSelectedLanguage();
    }

    initSelectedLanguage(): void {
        if (!this.currentLocale || !this.availableLanguages().length) return;
        this.selectedLanguage.set(this.languageService.getCurrentLanguage() ?? null);
    }

    selectLanguage(languageCode: string): void {
        const language = this.availableLanguages().find(lang => lang.code === languageCode);
        if (!language) {
            return;
        }
        this.selectedLanguage.set(language);
        this.languageService.switchLanguage(languageCode);
    }
}
